import styled from "styled-components";

export default styled.div`
  margin: 1rem 1rem 1rem 0;
  text-align: center;
  font-size: 1rem;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 1rem;
  height: calc(100vh - 6rem);
  max-height: calc(100vh - 6rem);
  flex: 1;
  width: 100vw;
  overflow-y: scroll;
  padding: 2rem;
`;
